var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_871_9171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.8026 0H15.1974C6.80409 0 0 6.80409 0 15.1974V50.8026C0 59.1959 6.80409 66 15.1974 66H50.8026C59.1959 66 66 59.1959 66 50.8026V15.1974C66 6.80409 59.1959 0 50.8026 0Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 40.5858V50.8027C65.9885 54.8298 64.3837 58.6887 61.5361 61.5362C58.6885 64.3838 54.8297 65.9886 50.8026 66.0001H40.5379L22.301 47.7633C21.9218 47.4165 21.6386 46.9776 21.4789 46.4893C21.3191 46.0009 21.2882 45.4795 21.3892 44.9756L17.7331 41.3152C17.2219 40.9546 16.8389 40.4404 16.6397 39.8474C16.4404 39.2544 16.4352 38.6133 16.6249 38.0171C16.8146 37.4209 17.1893 36.9007 17.6946 36.5318C18.1999 36.163 18.8096 35.9647 19.4353 35.9658H24.2463L17.7331 29.4526C17.2245 29.0902 16.844 28.5756 16.6467 27.983C16.4493 27.3904 16.4453 26.7505 16.6351 26.1554C16.8249 25.5604 17.1988 25.041 17.7028 24.6721C18.2068 24.3033 18.815 24.104 19.4396 24.1031H35.6053L39.1701 19.0098C40.2035 17.5379 42.1228 17.0993 43.4558 18.0329C43.7107 18.2118 43.9325 18.4336 44.1114 18.6885L66 40.5858Z",
    fill: "url(#paint0_linear_871_9171)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5 38.927C49.5 39.3142 49.4237 39.6975 49.2756 40.0553C49.1274 40.413 48.9102 40.738 48.6365 41.0117C48.3627 41.2855 48.0377 41.5027 47.68 41.6509C47.3223 41.799 46.9389 41.8753 46.5517 41.8753H19.4483C18.6664 41.8753 17.9164 41.5647 17.3635 41.0117C16.8106 40.4588 16.5 39.7089 16.5 38.927C16.5 38.1451 16.8106 37.3951 17.3635 36.8422C17.9164 36.2893 18.6664 35.9787 19.4483 35.9787H46.5517C46.9389 35.9787 47.3223 36.055 47.68 36.2031C48.0377 36.3513 48.3627 36.5685 48.6365 36.8422C48.9102 37.116 49.1274 37.441 49.2756 37.7987C49.4237 38.1564 49.5 38.5398 49.5 38.927ZM49.5 27.073C49.5 27.4602 49.4237 27.8436 49.2756 28.2013C49.1274 28.559 48.9102 28.884 48.6365 29.1578C48.3627 29.4316 48.0377 29.6487 47.68 29.7969C47.3223 29.9451 46.9389 30.0213 46.5517 30.0213H19.4483C18.6664 30.0213 17.9164 29.7107 17.3635 29.1578C16.8106 28.6049 16.5 27.855 16.5 27.073C16.5 26.2911 16.8106 25.5412 17.3635 24.9883C17.9164 24.4354 18.6664 24.1248 19.4483 24.1248H46.5517C46.9389 24.1248 47.3223 24.201 47.68 24.3492C48.0377 24.4973 48.3627 24.7145 48.6365 24.9883C48.9102 25.2621 49.1274 25.5871 49.2756 25.9448C49.4237 26.3025 49.5 26.6859 49.5 27.073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4644 18.0546C44.7975 18.9881 45.045 20.9421 44.0115 22.3967L26.8211 46.9687C25.7877 48.4406 23.8685 48.8792 22.5355 47.9456C21.2025 47.0121 20.955 45.0581 21.9884 43.6035L39.1788 19.0316C40.2122 17.5596 42.1184 17.121 43.4644 18.0546Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_871_9171",
    x1: 21.1764,
    y1: 21.1765,
    x2: 61.5363,
    y2: 61.5364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B71C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B71C1C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_871_9171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.59ea7aef446f63a47586af42a5a8e904.svg";
export { ForwardRef as ReactComponent };